<template>
  <div class="setPasswordBox">
    <v-head :title="flag == 'set' ? '设置支付密码' : '重置支付密码'"></v-head>
    <el-steps
      style="width: 1493px; margin: 30px 0 25px"
      :active="active"
      finish-status="success"
      align-center
      v-if="!isShowBox4"
    >
      <el-step title="验证身份"
        ><div slot="icon" class="icon_circle"></div
      ></el-step>
      <el-step title="设置支付密码"
        ><div slot="icon" class="icon_circle"></div
      ></el-step>
      <el-step title="设置成功"
        ><div slot="icon" class="icon_circle"></div
      ></el-step>
    </el-steps>
    <!-- 设置密码 -->
    <template v-if="flag == 'set'">
      <!-- 第一步 -->
      <div class="mainBox" v-if="active == 0">
        <div class="mainBox_title">
          您正在使用"<span style="color: #84c049">验证短信</span>"进行校验。
        </div>
        <div class="mainBox_main">
          <el-form label-position="right" label-width="69px">
            <el-form-item label="手机号码">
              <span style="font-size: 14px">159******33</span>
              <span class="mainBox_sendBtn">点此免费获取</span>
            </el-form-item>
            <el-form-item label="校验码">
              <el-input
                v-model="messageCode"
                placeholder="6位数字"
                style="width: 82px"
              ></el-input>
              <el-link class="mainBox_helpBtn" :underline="false"
                >没收到短信校验码？</el-link
              >
            </el-form-item>
          </el-form>
          <span class="mainBox_tip"
            ><i
              class="el-icon-success"
              style="color: #84c049; margin-right: 5px; font-size: 14px"
            ></i
            >效验码已发送到您的手机，30分钟内输入有效，请勿泄露。</span
          >
          <el-button
            type="primary"
            style="width: 109px; border-radius: 0; margin: 30px 28px 0 0"
            @click="next"
            >下一步</el-button
          >
        </div>
      </div>
      <!-- 第二步 -->
      <div class="mainBox2" v-if="active == 1">
        <el-form
          label-position="right"
          label-width="128px"
          style="margin-left: 105px"
        >
          <el-form-item label="手机号码">
            <span style="font-size: 14px; color: #84c049">159******33</span>
          </el-form-item>
          <el-form-item label="新的支付密码">
            <el-input v-model="password" style="width: 229px"></el-input>
            <span class="mainBox2_tip"
              >支付密码为6位数字<i
                class="el-icon-warning"
                style="margin-left: 5px; font-size: 14px"
              ></i
            ></span>
          </el-form-item>
          <el-form-item label="确认新的支付密码">
            <el-input v-model="confirmPassword" style="width: 229px"></el-input>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          style="width: 88px; border-radius: 0; margin: 8px 45px 0 0"
          @click="next"
          >确定</el-button
        >
      </div>
      <!-- 第三步 -->
      <div class="mainBox3" v-if="active == 2">
        <i class="el-icon-success" style="font-size: 60px; color: #84c049"></i>
        <span class="mainBox3_title">设置成功，请牢记新的支付密码</span>
        <span class="mainBox3_text"
          >3s后自动跳转到<span style="color: #f89a00">账户安全</span>页面</span
        >
      </div>
    </template>
    <!-- 重置密码 -->
    <template v-else>
      <!-- 选择重置方式 -->
      <div class="mainBox4" v-if="isShowBox4">
        <div class="mainBox4_title">
          您正在为账号<span style="color: #84c049">139******44</span
          >重置支付密码，请选择重置方式：
        </div>
        <div class="mainBox4_selectBox" @click="chooseMode">
          我忘记支付密码了
        </div>
        <div
          class="mainBox4_selectBox"
          @click="chooseMode"
          style="color: #f89a00"
        >
          我记得原支付密码
        </div>
      </div>
      <!-- 第一步 -->
      <div class="mainBox" v-if="active == 0 && !isShowBox4">
        <div class="mainBox_title">
          您正在使用"<span style="color: #84c049">验证支付密码</span>"进行校验。
        </div>
        <div class="mainBox_main">
          <el-form
            label-position="right"
            label-width="69px"
            style="margin-left: 153px"
          >
            <el-form-item label="支付密码">
              <el-input
                class="payPassword_input"
                v-model="payPassword"
                show-password
              ></el-input>
              <el-link
                class="mainBox_helpBtn"
                style="color: #f89a00"
                :underline="false"
                >忘记支付密码？</el-link
              >
            </el-form-item>
          </el-form>
          <span class="mainBox5_tip">请输入6位数字支付密码，还可输入2次</span>
          <div
            style="display: flex; align-items: center; margin: 30px 0 0 80px"
          >
            <el-button
              type="primary"
              style="width: 109px; border-radius: 0"
              @click="next"
              >下一步</el-button
            >
            <el-link
              class="mainBox_helpBtn"
              style="color: #000"
              :underline="false"
              >重新选择验证方式</el-link
            >
          </div>
        </div>
      </div>
      <!-- 第二步 -->
      <div class="mainBox2" v-if="active == 1">
        <el-form
          label-position="right"
          label-width="128px"
          style="margin-left: 105px"
        >
          <el-form-item label="手机号码">
            <span style="font-size: 14px; color: #84c049">159******33</span>
          </el-form-item>
          <el-form-item label="新的支付密码">
            <el-input v-model="password" style="width: 229px"></el-input>
            <span class="mainBox2_tip"
              >支付密码为6位数字<i
                class="el-icon-warning"
                style="margin-left: 5px; font-size: 14px"
              ></i
            ></span>
          </el-form-item>
          <el-form-item label="确认新的支付密码">
            <el-input v-model="confirmPassword" style="width: 229px"></el-input>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          style="width: 88px; border-radius: 0; margin: 8px 45px 0 0"
          @click="next"
          >确定</el-button
        >
      </div>
      <!-- 第三步 -->
      <div class="mainBox3" v-if="active == 2">
        <i class="el-icon-success" style="font-size: 60px; color: #84c049"></i>
        <span class="mainBox3_title">设置成功，请牢记新的支付密码</span>
        <span class="mainBox3_text"
          >3s后自动跳转到<span style="color: #f89a00">账户安全</span>页面</span
        >
      </div>
    </template>
  </div>
</template>

<script>
import vHead from "../common/header3.vue";
export default {
  components: {
    vHead,
  },
  data() {
    return {
      active: 0,
      messageCode: "",
      flag: "reset",
      isShowBox4: true,
      password: "",
      confirmPassword: "",
      payPassword: "",
    };
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    chooseMode() {
      this.isShowBox4 = !this.isShowBox4;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/resetPassword";
</style>



// WEBPACK FOOTER //
// src/components/page/resetPassword.vue